<!-- Bound to the dashboard's own MessageService: the host page's toast is
     wired to a different instance and cannot show these. -->
<p-toast position="top-right" />

<p-confirmDialog
  key="positionDialog"
  position="center"
  rejectButtonStyleClass="p-button-outlined"
  appendTo="body"
  #cd
>
  <ng-template pTemplate="footer">
    <div class="flex w-full flex-row gap-2">
      <button
        type="button"
        mat-flat-button
        style="border: 2px solid #6e6e6e"
        class="w-1/2"
        (click)="cd.onReject()"
      >
        Cancella
      </button>
      <button
        type="button"
        mat-flat-button
        color="accent"
        class="w-1/2"
        (click)="cd.onAccept()"
      >
        Conferma
      </button>
    </div>
  </ng-template>
</p-confirmDialog>

@let module = forms.moduleStructure();
@let ready = forms.ready();

@if (ready && module) {
  <p-tabs
    [value]="effectiveTab()"
    (valueChange)="onTabChange($event)"
    class="w-full"
  >
    <p-tablist class="flex-0" [pt]="tabListPt">
      @if (mode() === 'full') {
        <p-tab [value]="0" data-tour="tab-summary">Sommario</p-tab>
      }
      <p-tab [value]="1" data-tour="tab-administrative">Offerta Amministrativa</p-tab>
      <p-tab [value]="2" data-tour="tab-technical">Offerta Tecnica</p-tab>
      <p-tab [value]="3" data-tour="tab-economic">Offerta Economica</p-tab>
      @if (mode() === 'full') {
        <p-tab [value]="4" data-tour="tab-results">Risultati</p-tab>
      }
      @if (hasSettingsTab()) {
        <!-- The divider sets the page's own tab apart from the answer's. -->
        <span class="tab-divider" aria-hidden="true">|</span>
        <p-tab [value]="SETTINGS_TAB" data-tour="tab-settings">
          <i class="pi pi-cog mr-2"></i>Impostazioni
        </p-tab>
      }
    </p-tablist>
    <p-tabpanels class="min-h-0 flex-auto bg-transparent">
      @if (mode() === 'full') {
        <p-tabpanel [value]="0" class="w-full">
          @if (effectiveTab() === 0) {
            <div class="flex w-full">
              <lib-compiling-summary
                class="mx-auto flex w-full max-w-screen-lg"
              />
            </div>
          }
        </p-tabpanel>
      }
      <p-tabpanel [value]="1" class="w-full">
        <div class="flex w-full">
          <lib-applicant-form
            [mode]="mode()"
            class="mx-auto flex w-full max-w-screen-lg"
          />
        </div>
      </p-tabpanel>
      <p-tabpanel [value]="2" class="w-full">
        <lib-envelop-b class="w-full" />
      </p-tabpanel>
      <p-tabpanel [value]="3" class="w-full">
        <lib-envelope-c class="block w-full" [mode]="mode()" />
      </p-tabpanel>
      @if (mode() === 'full') {
        <p-tabpanel [value]="4" class="w-full">
          <lib-result />
        </p-tabpanel>
      }
      @if (settingsTab(); as settings) {
        @if (hasSettingsTab()) {
          <p-tabpanel [value]="SETTINGS_TAB" class="w-full">
            @if (effectiveTab() === SETTINGS_TAB) {
              <ng-container *ngTemplateOutlet="settings" />
            }
          </p-tabpanel>
        }
      }
    </p-tabpanels>
  </p-tabs>

  <!-- Docked bottom-right, outside the tabs and out of the page flow: a bulk
       compile runs for minutes, so its progress has to survive a tab change and
       scrolling without ever displacing the form. -->
  <lib-bulk-compile-status />
}
